import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { promises } from 'dns';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { SuperAdminService } from 'src/app/services/super-admin.service';

@Component({
  selector: 'app-geo-mapping',
  templateUrl: './geo-mapping.component.html',
  styleUrls: ['./geo-mapping.component.scss']
})
export class GeoMappingComponent implements OnInit {

  @ViewChild('targetTable', { static: true })
  public targetTable: Table;

  public loading: boolean = false;

  public targetTableData: any = [];
  public userTypeData: any = [];
  public geoNameData: any = [];
  public cropTypeData: any = [];
  public programTypeData: any = [];
  public userId: any;

  public displayTargetDialog: boolean = false;
  public selectedUserType: any;
  public selectedGeoName: any;
  public selectedCropType: any;
  public selectedProgramType: any;
  public area: any;
  public farmerToBenifit: any;
  public Amount: any;
  public startDate: any;
  public endDate: any;

  public addTargetDetails: FormGroup;
  public isInvalid: boolean = false;
  public startDateVal: Date;

  public rowValue: any = null;
  public isEditCase: boolean = false;
  public userData:any;
  public actionData:any
  public selectedUserData:any
  public selectedActionData:any
  public selectedGeoTypeData:any
  public geoTypeData:any
  public selectedGeoNameData:any
  public geoTypeName:any

  constructor(
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private services: SuperAdminService,
    private _fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;


    this.addTargetDetails = this._fb.group({
      userType: ['', Validators.required],
      user: ['', Validators.required],
      action: ['', Validators.required],
      geoType: ['', Validators.required],
      geoName: ['', Validators.required],
      active: [0, Validators.required]
      
    });
    


    this.loadTableData();
  }

  loadTableData() {
    this.loading = true;
    this.services
      .getGeoUserMapping()
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data.length > 0) {
            this.targetTableData = data;
          } else {
            this.targetTableData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: "Data Not Found",
            });
          }
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Target System Grid Load', '', new Date(), 'Success');
        },
        error: (err) => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
          this.activityRecordService.activityRecord(this.userId, 'Target System Grid Load', '', new Date(), err);
        },
      });
      
  }

  refreshTable() {
    this.loadTableData();
  }

  addTarget() {
    this.displayTargetDialog = true;
    this.getGeoTypeNameCropProgram();
  }

  getGeoTypeNameCropProgram() {

    this.loader.start();
    this.services
      .getGeoUserType()
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data.length > 0) {           
            this.userTypeData = data[1];
            
          } else {
            this.userTypeData = [];
            
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: "Dropdown Data Not Found",
            });
          }
          this.loader.close();
          // this.activityRecordService.activityRecord(this.userId, 'Click on Add Target', '', new Date(), 'Success');
        },
        error: (err) => {
          this.userTypeData = [];
         
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
      this.services
      .getGeoTypeNameCropProgram()
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data.length > 0) {
            this.geoTypeData = data[0];
          } else {
            this.geoTypeData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: "Data Not Found",
            });
          }
          this.loading = false;
          // this.activityRecordService.activityRecord(this.userId, 'Target System Grid Load', '', new Date(), 'Success');
        },
        error: (err) => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
          this.activityRecordService.activityRecord(this.userId, 'Target System Grid Load', '', new Date(), err);
        },
      });
  }


  onCloseDialog() {
    this.displayTargetDialog = false;
    this.addTargetDetails.reset();
    // this.isInvalid = false;
    // this.isEditCase = false;
    // this.rowValue = null;

    // this.userTypeData = [];
    // this.cropTypeData = [];
    // this.programTypeData = [];
    // this.area = null;
    // this.farmerToBenifit = null;
    // this.Amount = null;
    // this.startDate = null;
    // this.endDate = null;
     this.userData=[]
     this.actionData=[]
    
    
     this.geoTypeData=[]
     
     this.geoTypeName=[]
     this.userTypeData=[]

  }

  get addTargetControls() {
    return this.addTargetDetails.controls;
  }

  onSaveAddGeoMapping() { 

      let val = this.addTargetDetails.value;
      let reqBody = {
        "autoID": 0,
        "userID": val?.user?.UserID,
        "geoID": val.geoName.Code,
        "geoTypeName": val.geoType.geoTypeName,
        "actionId": val?.action?.ActionID, 
        "active": 0
      }

      this.addgeoMapping(reqBody);
    
  }

  addgeoMapping(reqBody) {
    this.loader.start();
    this.services
      .addUpdateUserGeoMapping(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {

          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: data,
          });
          this.loadTableData();
          this.onCloseDialog();

          this.loader.close();
          // this.activityRecordService.activityRecord(this.userId, 'Click on Add Target', '', new Date(), 'Success');
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
     
  }


  onRowDelete(val) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteRow(val?.AutoID)
      }
    });

    // this.deleteRow(val?.AutoID)
  }

  deleteRow(autoId) {
    this.loader.start();
    this.services
      .deleteUserGeoMapping(autoId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data == "Success") {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });

            // this.loadTableData();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        
          this.loader.close();
          this.loadTableData();
          // this.activityRecordService.activityRecord(this.userId, 'Click on Add Target', '', new Date(), 'Success');
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectUserType() {
    this.callGooeNameData(this.selectedUserType);
  }


  callGooeNameData(userType) {
    this.loader.start();
    this.services
      .getUserActionFromUserType(userType.Level_ID)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data.length > 0) {
            this.userData = data[0];
            this.actionData=data[1];            
          } else {
            this.userData = [];
            this.actionData=[];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: "GeoName Data Not Found",
            });
          }
          this.loader.close();
        },
        error: (err) => {
          this.userData = [];
            this.actionData=[];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  editTarget(row) {
    let active= row.Active==0?1:0
    this.confirmationService.confirm({
      message:row.Active==0?'Do you want to change Active status to 1':'Do you want to change Active status to 0',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let reqBody = {
          AutoId: row.AutoID,
          Active:active,
        }
        this.loading = true;
        this.services.updateStatusUserGeoMapping(reqBody)
          .pipe(first())
          .subscribe({
            next: (data) => {
              this.loading = false;
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
              this.loadTableData();
            },
            error: (err) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

            }
          });
      }
    });
  }


  toISOLocal(d) {
    var z = n => ('0' + n).slice(-2);
    var off = d.getTimezoneOffset();
    off = Math.abs(off);

    return d.getFullYear() + '-'
      + z(d.getMonth() + 1) + '-' +
      z(d.getDate());
  }

  onSelectUser(){
  }

  onSelectGeoType(){
    this.services
    .getGeoByType(this.selectedGeoTypeData.geoTypeName)
    .pipe(first())
    .subscribe({
      next: (data) => {
        if (data.length > 0) {         
          this.geoTypeName = data;          
        } else {
          this.userTypeData = [];
          
          this.messageService.add({
            severity: 'info',
            summary: 'Info Message',
            detail: "Dropdown Data Not Found",
          });
        }
        this.loader.close();
        // this.activityRecordService.activityRecord(this.userId, 'Click on Add Target', '', new Date(), 'Success');
      },
      error: (err) => {
        this.geoTypeName = [];
       
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      },
    });
  }
  onSelectGeoName(){

  }
}
